$(document).ready(function() {
  var pageId = '',
      introViewed = false,
      noPopup = sessionStorage.getItem('changePasswordPopup');

  if ($('.ph-supporthub__supportooltips').length > 0) {
    pageId = 'resetallpage';
  } else {
    pageId = $('.ph-pagename').text();
  }

  ACC.introjs = {
      bindFunction: function() {
        $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/y_intro.js', function() {
          introJs().start();
        });
      },
      bindClickEvent: function() {
        $.ajax({
          type: 'POST',
          url: ACC.config.contextPath + '/updateCustomerIntro',
          data: {
            introViewed : introViewed,
            pageId : pageId
          },
          success: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      },
      anonymousIntroCookie: function(cookieName, cookiePath) {
      if (ACC.healthcare.getCookieValue(cookieName) !== 'true' && ($('.ph-introjsvalue').text() === 'true')) {
        if ($('.ph-notloggedIn').length > 0){
          if ($('.ph-anonymous_healthcare__professional--main').length > 0) {
            $(document).on('click', '.ph-anonymous_healthcare__professional--submit' , function(){
              if ($('.ph-anonymous_healthcare__professional--checkboxerror').hasClass('hidden')) {
                ACC.introjs.bindFunction();
                document.cookie = cookiePath;
              }
            });
          } else {
            ACC.introjs.bindFunction();
            document.cookie = cookiePath;
          }
        }
      }
     }
  };

  if ($('.ph-page-search').find('.ph-notloggedIn').length > 0) {
    ACC.introjs.anonymousIntroCookie('introAnonymousSearchPage', 'introAnonymousSearchPage=true;path=/');
  }

  if ($('.ph-page-anonymousOrderSearch').length > 0) {
    ACC.healthcare.introAnonymousOrderSearchPage();
    ACC.introjs.anonymousIntroCookie('introAnonymousOrderSearchPage', 'introAnonymousOrderSearchPage=true;path=/');
  }

  if ($('.ph-page-productList').find('.ph-notloggedIn').length > 0) {
    ACC.introjs.anonymousIntroCookie('introAnonymousDecisionPage', 'introAnonymousDecisionPage=true;path=/');
  }
  
  if ($('.ph-page-cartPage').find('.ph-notloggedIn').length > 0) {
    ACC.introjs.anonymousIntroCookie('introAnonymousCartPage', 'introAnonymousCartPage=true;path=/');
    if ($('.ph-emptylink').text().trim(' ').length === 0) {
	  $('.ph-emptylink').removeAttr('data-step').removeAttr('data-intro');
	}
  }

  if ($('.ph-introjsvalue').text() === 'true' && (noPopup === 'false' ||
  $("#cboxLoadedContent .ph-anonymous_healthcare__professional--submit").length === 0 ||
   $('.ph-encodedType').attr('data-encodeValue') !== 'true') && $('.ph-page-homepage').length === 0) {
    if ($('.ph-showIntroToUser').text() === 'true') {
      ACC.introjs.bindFunction();
    }
  }

  $(document).on('click', '.ph-supporthub__supporttooltipsdescription', function(e) {
    ACC.introjs.bindClickEvent();
    e.stopPropagation();
  });

  $(document).on('click', '.introjs-skipbutton', function(e) {
    introViewed = true;
    ACC.introjs.bindClickEvent();
    e.stopPropagation();
  });
  
  
  $(document).mouseup(function(e) {
    var introContainer = $(".introjs-tooltip");

    if (!$('.ph-pagename').hasClass('alreadyClicked')) {
      if (!introContainer.is(e.target) && introContainer.has(e.target).length === 0) {
        if ($('.ph-introjsvalue').text() === 'true' && $('.ph-showIntroToUser').text() === 'true') {
          introViewed = true;
          ACC.introjs.bindClickEvent();
          $('.ph-pagename').addClass('alreadyClicked');
        }
      }
    }
    e.stopPropagation();
  });
});
